// default email validation regex EmailRegExp taken from CMS.Helpers.ValidationHelper Assembly
// validation used in Kentico CMSWebParts_Membership_Registration_RegistrationForm
// https://cmmiinstitute.visualstudio.com/_git/CmmiWebsite?path=/CMS/CMSWebParts/Membership/Registration/RegistrationForm.ascx.cs
// https://cmmiinstitute.visualstudio.com/_git/CmmiWebsite?path=/CMS/CMSFormControls/Inputs/EmailInput.ascx.cs
export const EmailRegEx = new RegExp(
  "^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)" +
    '*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?$',
  ''
);

export const UsernameRegexEx = new RegExp('^[a-zA-Z0-9_.@-]*$');

// EmailMaxLength taken from CMSWebParts_Membership_Registration_RegistrationForm
// https://cmmiinstitute.visualstudio.com/_git/CmmiWebsite?path=/CMS/CMSWebParts/Membership/Registration/RegistrationForm.ascx.cs
export const EmailMaxLength = 100;

export const firstNameMaxLength = 100;
export const lastNameMaxLength = 100;
